import React from 'react';
import { FlexBox, Pill, Spacer } from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import ReactI18n from 'react-i18n';
import getFeaturedLocationFeatures from '../../../utils/wls-location-features';

// Renders the set "view / location" features (Mountain view, Lake view,
// Waterfront, …) as standard ui-kit pills in their own row under the listing
// summary. Returns null when the listing has no location features set.
const LocationFeatureChips = () => {
  const listing = useSelector(state => state.listing);
  const translate = ReactI18n.getIntlMessage;

  const featureKeys = getFeaturedLocationFeatures(
    listing.property && listing.property.features_location
  );

  if (featureKeys.length === 0) return null;

  return (
    <>
      <Spacer size="xs" />
      <FlexBox
        alignItems="center"
        flexWrap="wrap"
        gap="xs"
        className="detailsLocationChips"
      >
        {featureKeys.map(featureKey => (
          <Pill key={featureKey} color="blue">
            {translate(`global.features.features_location.${featureKey}`)}
          </Pill>
        ))}
      </FlexBox>
    </>
  );
};

export default LocationFeatureChips;
